<template>
  <div class="q-pa-md q-gutter-sm">
    <q-dialog
      v-model="persistent"
      persistent
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="bg-teal text-white" style="width: 600px">
        <q-card-section>
          <div class="text-h6">Inatividade detectada</div>
        </q-card-section>

        <q-card-section class="bg-white text-teal">
          Dentro de 1 minutos você sera deslogado automaticamente do sistema se
          não demonstrar atividade
        </q-card-section>

        <q-card-section class="bg-white text-negative contador">
          {{ minutos }}:{{ segundos }}
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch, inject } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const keycloak = inject("keycloak");
    const store = useStore();
    const persistent = ref(false);
    const segundos = ref(59);
    const minutos = ref(0);
    const time = ref();
    const myInterval = ref(null);
    watch(
      () => store.state.idleVue.isIdle,
      () => {
        clearInterval(myInterval.value);

        persistent.value = store.state.idleVue.isIdle;
        if (persistent.value == true) {
          segundos.value = 59;
          minutos.value = 0;
          contagem();
        }
      }
    );

    const contagem = async () => {
      myInterval.value = setInterval(() => {
        time.value = segundos.value--;
        if (segundos.value == 0 && persistent.value) {
          store.dispatch("autenticacao/logout");
          keycloak.logout({ redirectUri: window.location.origin });
        }
      }, 1000);
    };

    return {
      persistent,
      segundos,
      minutos,
      contagem,
      time,
      myInterval,
    };
  },
};
</script>

<style scoped>
.contador {
  font-weight: bolder;
  font-size: 17px;
}
</style>
